import { render } from "./SavedArticles.vue?vue&type=template&id=16a8d589&scoped=true"
import script from "./SavedArticles.vue?vue&type=script&lang=js"
export * from "./SavedArticles.vue?vue&type=script&lang=js"

import "./SavedArticles.vue?vue&type=style&index=0&id=16a8d589&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16a8d589"

export default script